<template>
    <div class="animated fadeIn">
        <div v-if="loading" class="loading-container">
            <atom-spinner
                :animation-duration="1000"
                :size="60"
                color="#ff1d5e"
            />
        </div>
        <div v-else>
            <component-header
                title="Q&A Configuration"
                @create-press="createSurveyRoute"
                createButtonText="Create Survey"
                :hasback="true"
                :hasCreate="true"
                :hasSearch="true"
                :hasReload="true"
                :isLoading="loading"
                @reload-data="getSurveyList"
                @back-press="$router.push('./dashboard')"
                 @search-query="filter = $event"
            />
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <div class="table-wrapper">
                        <b-table
                            class="survey-table tableRadius"
                            id="survey-table"
                            :dark="dark"
                            :hover="hover"
                            :striped="striped"
                            :bordered="bordered"
                            :small="small"
                            :fixed="fixed"
                            responsive
                            :items="surveyList"
                            :fields="surveyColumns"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            :filter-included-fields="['title', 'description']"
                            thead-class="header"
                            show-empty
                            :busy="loading"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <b-button
                                    size="sm"
                                    class="button-circle mr-2"
                                    variant="primary"
                                    @click="editSurvey(data.item)"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                            </div>
                        </template>
                        </b-table>
                        <div class="pagination-wrapper">
                            <b-pagination
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="surveyList.length"
                                aria-controls="survey-table"
                                prev-text="Prev"
                                next-text="Next"
                                hide-goto-end-buttons
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
export default {
    name: "surveylist",
    components: {
        AtomSpinner,
        ComponentHeader,
    },
    data() {
        return {
            filterCount: 0,
            loading: false,
            perPage: 10,
            currentPage: 1,
            filter: "",
            loading: false,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            context: "Add",
            sortBy: "createdAtRaw",
            sortDesc: true,
            surveyColumns: [
                {
                    key: "title",
                    label: "Ttile",
                    sortable: true,
                },
                {
                    key: "description",
                },
                {
                    key: "createdAt",
                    label: "CREATED AT",
                    sortable: true,
                    sortKey: "createdAtRaw",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            questionList: (state) => state.survey.questionList,
        }),
        surveyList() {
            const list = this.questionList.data || [];
            const mapped = list.map((question) => ({
                _id: question._id,
                title: question.title,
                description: question.description,
                createdAt: moment(question.createdAt).format(
                    "DD-MM-YYYY HH:mm:ss",
                ),
                createdAtRaw: question.createdAt
                    ? new Date(question.createdAt).getTime()
                    : 0,
            }));
            // Sort by newest first (descending order)
            return mapped.sort((a, b) => b.createdAtRaw - a.createdAtRaw);
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        createSurveyRoute() {
            this.$router.push({ name: "Create Q&A" });
        },
        editSurvey(item) {
            this.$router.push({
                name: "Edit Q&A",
                params: { surveyId: item._id },
            });
        },
        async getSurveyData(e) {
            this.currentPage = e;
            await this.getSurveyList();
        },
        async getSurveyList() {
            this.loading = true;
            await this.$store
                .dispatch("survey/fetchQuestionSet")
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
    async mounted() {
        this.getSurveyList();
    },
};
</script>

<style scoped>
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

.table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.survey-table {
    border-radius: 12px;
}

.pagination-wrapper {
    float: right;
    margin-top: 1rem;
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        float: none;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }
}

.edit {
    color: white !important;
}

.text-center {
    text-align: center;
}

.form-div label {
    margin-top: 8px;
}

@media (max-width: 767.98px) {
    .table-wrapper {
        margin: 0 -15px;
    }
}
</style>
